module.exports = __webpack_public_path__ + "static/media/placeholder-image.c57d7605.png";